module.exports = __webpack_public_path__ + "static/media/contact_info_add.73c245b7.svg";